import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  //Bunga : lagi didepan rumah kalau didkeetin trigger auto next 'stage;, dia bilang ulang tahn
  {
    x: 5820,
    y: 2250,
    name: 'Diana',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_diana.png', // Use NPC image
    dialogTree: {
      startDialogId: 'diana_1',
      nodes: {
        diana_1: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Aku takut kak.. Apa yang harus kita lakukan!`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/diana.png',
          isEnd: true
        },
        //suruh tenang dulu. jelasin
      },
    },
  },
  {
    x: 5780,
    y: 2280,
    name: '',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_sondakh_dead.png', // Use NPC image
    repeatable  :true,
    dialogTree: {
      startDialogId: 'sondakh_1',
      nodes: {
        sondakh_1: {
          id: 'bunga_part2_1',
          speaker: 'Yan',
          text: `Ini adalah... Sondakh?`,
          backgroundImage: '/assets/cutscene/death_sondakh.jpg',
          nextDialogId : "sondakh_2",
        },
        sondakh_2: {
          id: 'bunga_part2_1',
          speaker: 'Yan',
          text: `Tidak bisa dikenali lagi...`,
          backgroundImage: '/assets/cutscene/death_sondakh.jpg',
          nextDialogId : "sondakh_3",
        },
        sondakh_3: {
          id: 'bunga_part2_1',
          speaker: 'Yan',
          text: `Sebaiknya kita teliti baik-baik.`,
          backgroundImage: '/assets/cutscene/death_sondakh.jpg',
          nextDialogId : "sondakh_choice",
        },
        sondakh_choice: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Sebaiknya kita teliti baik-baik.`,
          backgroundImage: '/assets/cutscene/death_sondakh.jpg',
          nextDialogId : "sondakh_4",
          choices: [
            {
              text: 'Perhatikan badan Sondakh',
              nextDialogId: 'sondakh_a1',
            },
            {
              text: 'Perhatikan baju sondakh',
              nextDialogId: 'sondakh_b1',
            },
            {
              text: 'Perhatikan darah sondakh',
              nextDialogId: 'sondakh_c1',
            },
            {
              text: 'Kembali',
              nextDialogId: 'sondakh_c1',
              isEnd : true
            }
          ],
        },
        sondakh_a1: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Seluruh badan Sondakh menyusut dan mengering.`,
          backgroundImage: '/assets/cutscene/death_sondakh_body_zoom.jpg',
          nextDialogId : "sondakh_a2",
        },
        sondakh_a2: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Tidak ada daging tersisa, hanya kulit yang menempel ke tulang`,
          backgroundImage: '/assets/cutscene/death_sondakh_body_zoom.jpg',
          nextDialogId : "sondakh_choice",
        },
        sondakh_b1: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Bagian kanan baju Sondakh koyak`,
          backgroundImage: '/assets/cutscene/death_sondakh_body_zoom.jpg',
          nextDialogId : "sondakh_b2",
        },
        sondakh_b2: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Apakah kita bisa menemukan sobekan baju ini?`,
          backgroundImage: '/assets/cutscene/death_sondakh_body_zoom.jpg',
          nextDialogId : "sondakh_choice",
        },
        sondakh_c1: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Darah muncul dari mulut, mata, dan seluruh tempat lain.`,
          backgroundImage: '/assets/cutscene/death_sondakh.jpg',
          nextDialogId : "sondakh_c2",
        },
        sondakh_c2: {
          id: 'sondakh_4',
          speaker: 'Yan',
          text: `Air-air dipinggir danau ini juga penuh dengan darah yang sama`,
          backgroundImage: '/assets/cutscene/death_sondakh.jpg',
          nextDialogId : "sondakh_choice",
        },
      },
    },
  },
  {
    x: 4700,
    y: 2500,
    name: 'Bunga',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga_1',
      nodes: {
        bunga_1: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Halo Yan. Apakah ada kejadian?`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga_2',
        },
        bunga_2: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Aku mendengar keributan dari jauh`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga_3',
        },
        bunga_3: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Aku mendengar keributan`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/bunga.png',
          choices: [
            {
              text: 'Diana dan Elsa menemukan mayat di sisi lain danau.',
              nextDialogId: 'bunga4',
            },
            {
              text: 'Sebaiknya kita bergegas. Ada mayat ditemukan di sisi lain danau.',
              nextDialogId: 'bunga4',
            }
          ],
        },
        bunga_4: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Mayat? Apa yang terjadi?`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga_5',
        },
        bunga_5: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Maaf aku terkejut. Ayo kita bergegas`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/bunga.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 5950,
    y: 2050,
    name: 'Ato',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_ato.png', // Use NPC image
    dialogTree: {
      startDialogId: 'ato_1',
      nodes: {
        ato_1: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Apa yang sedang terjadi...`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/ato.png',
          nextDialogId : "ato_2"
        },
        ato_2: {
          id: 'ato_2',
          speaker: 'Ato',
          text: `Apakah gadis kota baru itu?`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/ato.png',
          nextDialogId : "ato_3"
        },
        ato_3: {
          id: 'ato_3',
          speaker: 'Ato',
          text: `Siapapun dalang dibalik kejadian ini tidak akan kita maafkan!`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/ato.png',
          isEnd : true
        },
        //suruh tenang dulu. jelasin
      },
    },
  },
  {
    x: 5850,
    y: 2150,
    name: 'Romo Darius',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_darius.png', // Use NPC image
    repeatable : true,
    dialogTree: {
      startDialogId: 'darius_1',
      nodes: {
        darius_1: {
          id: 'darius_1',
          speaker: 'Romo Darius',
          text: `Sangat malang sekali kejadian ini.`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/darius.png',
          nextDialogId : "darius_2"
        },
        darius_2: {
          id: 'darius_2',
          speaker: 'Romo Darius',
          text: `Sebaiknya kita cepat kembali ke desa untuk memberikan prosesi pemakaman, agar jiwanya damai.`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/darius.png',
          nextDialogId : "darius_3"
        },
        darius_3: {
          id: 'darius_3',
          speaker: 'Romo Darius',
          text: `Apakah kamu siap?`,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/darius.png',
          nextDialogId : "darius_4"
        },
        darius_4: {
          id: 'darius_3',
          speaker: 'Romo Darius',
          text: ``,
          backgroundImage: '/assets/backdrop/danau.png',
          characterImage: '/assets/character/v2/darius.png',
          choices: [
            {
              text: 'Ayo kita cepat kembali ke desa.',
              nextDialogId: 'darius_5',
              storyAction: { type: 'nextDay', value: 0 },
            },
            {
              text: 'Aku masih ingin mencari tahu apa yang terjadi',
              nextDialogId: 'darius_5',
              isEnd : true
            }
          ],
        },
      },
    },
  },
];

export default config;
